/**
 * Verification tier labels — single source of truth.
 *
 * QA finding: PatientBanner used 'Weakly Verified' / 'Strongly Verified' while
 * the Dashboard used 'Verified — weak' / 'Verified — strong' for the same
 * tiers. Both components now consume this one constant so the labels can never
 * drift apart again.
 *
 * Indexed by tier level (1..4). Index 0 is unused (no tier 0).
 */
export const VERIFICATION_TIERS = [
  null, // index 0 — unused
  { level: 1, name: 'Declared', short: 'Declared' },
  { level: 2, name: 'Verified — weak', short: 'Weakly Verified' },
  { level: 3, name: 'Verified — strong', short: 'Strongly Verified' },
  { level: 4, name: 'Authoritative', short: 'Authoritative' },
] as const

export type VerificationTier = 1 | 2 | 3 | 4

/** Full label for a tier level, e.g. 'Verified — weak'. */
export function verificationTierName(tier: VerificationTier): string {
  return VERIFICATION_TIERS[tier]?.name ?? 'Unknown'
}

/** Short label for a tier level, e.g. 'Weakly Verified'. */
export function verificationTierShort(tier: VerificationTier): string {
  return VERIFICATION_TIERS[tier]?.short ?? 'Unknown'
}
